import {spotheroDelete} from 'api';
import {catchApiResponse} from 'utils/api';
import {sendSentryException} from 'utils/error-handling';

/**
 * Deletes an inventory rule exception for a given facility
 *
 * @param facilityId - The facility id.
 * @param ruleId - The rule id.
 *
 *
 * @see https://spothero.com/api/v1/docs/endpoints/?new-docs=true#!/Facilities/delete_facilities_facility_id_inventory_rules_inventory_rule_id
 * @see '/api/v1/facilities/{facilityId}/inventory-rules/{ruleId}/'
 */
const removeException = async (facilityId: number, ruleId: number) => {
    try {
        await spotheroDelete(
            `facilities/${facilityId}/inventory-rules/${ruleId}/`
        );
    } catch (error) {
        sendSentryException(error);
        catchApiResponse(error);
    }
};

export default removeException;
